import {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';
import {
  deleteReactionCodePayload,
  SetEditRedactionCodePayload,
  SaveRedactionCodeRequestPayload,
  SaveRedactionCodeSuccessPayload,
  CheckRedactionCodePayload,
} from '../models';
import { FetchRedactionCodesResponse } from '../services';
import { createAction } from '@reduxjs/toolkit';
import { DeleteRedactionCodeQueryResponse } from '../services/queries';

export const TOGGLE_IS_DRAWER_OPEN = createAction(
  'REDACTION_CODES/TOGGLE_IS_DRAWER_OPEN'
);

export const FETCH_REDACTION_CODES = createAction(
  'REDACTION_CODES/GET_REDACTION_CODES'
);
export const FETCH_ALL_REDACTION_CODES = createAction(
  'REDACTION_CODES/GET_ALL_REDACTION_CODES'
);
export const FETCH_REDACTION_CODES_SUCCESS =
  createGraphQLSuccessAction<FetchRedactionCodesResponse>(
    'REDACTION_CODES/GET_REDACTION_CODES_SUCCESS'
  );
export const FETCH_REDACTION_CODES_FAILURE = createGraphQLFailureAction<
  unknown,
  Record<string, any>,
  true
>('REDACTION_CODES/GET_REDACTION_CODES_FAILURE');

export const SET_EDIT_REDACTION_CODE =
  createAction<SetEditRedactionCodePayload>(
    'REDACTION_CODES/SET_EDIT_REDACTION_CODE'
  );
export const CLEAR_SELECTED_EDIT_REDACTION_CODE = createAction(
  'REDACTION_CODES/CLEAR_SELECTED_EDIT_REDACTION_CODE'
);

export const DELETE_REDACTION_CODE_REQUEST =
  createAction<deleteReactionCodePayload>(
    'REDACTION_CODES/DELETE_REDACTION_CODE_REQUEST'
  );
export const DELETE_REDACTION_CODE_SUCCESS =
  createGraphQLSuccessAction<DeleteRedactionCodeQueryResponse>(
    'REDACTION_CODES/DELETE_REDACTION_CODE_SUCCESS'
  );
export const DELETE_REDACTION_CODE_FAILURE = createGraphQLFailureAction(
  'REDACTION_CODES/DELETE_REDACTION_CODE_FAILURE'
);

export const CHECK_REDACTION_CODE_EXISTS_SUCCESS =
  createAction<CheckRedactionCodePayload>(
    'REDACTION_CODES/CHECK_REDACTION_CODE_EXISTS_SUCCESS'
  );
export const CHECK_REDACTION_CODE_EXISTS_FAILURE = createAction(
  'REDACTION_CODES/CHECK_REDACTION_CODE_EXISTS_FAILURE'
);

export const SAVE_REDACTION_CODE_REQUEST =
  createAction<SaveRedactionCodeRequestPayload>(
    'REDACTION_CODES/SAVE_REDACTION_CODE_REQUEST'
  );
// export const SAVE_REDACTION_CODE_SUCCESS = createGraphQLSuccessAction(
//   'REDACTION_CODES/SAVE_REDACTION_CODE_SUCCESS'
// );
export const SAVE_REDACTION_CODE_SUCCESS =
  createGraphQLSuccessAction<SaveRedactionCodeSuccessPayload>(
    'REDACTION_CODES/SAVE_REDACTION_CODE_SUCCESS'
  );
export const SAVE_REDACTION_CODE_FAILURE = createGraphQLFailureAction(
  'REDACTION_CODES/SAVE_REDACTION_CODE_FAILURE'
);

export const ON_CHANGE_PAGE = createAction<{ offset: number }>(
  'REDACTION_CODES/ON_CHANGE_PAGE'
);
export const ON_CHANGE_PAGE_SIZE = createAction<{ limit: number }>(
  'REDACTION_CODES/ON_CHANGE_PAGE_SIZE'
);

export const FETCH_COUNT_REDACTION_CODES = createAction(
  'REDACTION_CODES/FETCH_COUNT_REDACTION_CODES'
);
export const FETCH_COUNT_REDACTION_CODES_SUCCESS = createAction<{
  count: number;
}>('REDACTION_CODES/FETCH_COUNT_REDACTION_CODES_SUCCESS');
export const FETCH_COUNT_REDACTION_CODES_FAILURE =
  'REDACTION_CODES/FETCH_COUNT_REDACTION_CODES_FAILURE';

export const actionToggleIsDrawerOpen = () => TOGGLE_IS_DRAWER_OPEN();

export const actionSaveRedactionCode = (
  payload: SaveRedactionCodeRequestPayload
) => SAVE_REDACTION_CODE_REQUEST(payload);

export const actionFetchRedactionCodes = FETCH_REDACTION_CODES;

export const actionFetchAllRedactionCodes = FETCH_ALL_REDACTION_CODES;

export const actionDeleteRedactionCode = (payload: deleteReactionCodePayload) =>
  DELETE_REDACTION_CODE_REQUEST(payload);

export const actionSetEditRedactionCode = (
  payload: SetEditRedactionCodePayload
) => SET_EDIT_REDACTION_CODE(payload);

export const actionClearSelectedRedactionCode = () =>
  CLEAR_SELECTED_EDIT_REDACTION_CODE();

export const onChangePage = (offset: number) =>
  ON_CHANGE_PAGE({
    offset,
  });

export const onChangePageSize = (limit: number) =>
  ON_CHANGE_PAGE_SIZE({ limit });

export const fetchCountRedactionCodes = () => FETCH_COUNT_REDACTION_CODES();

export const fetchCountRedactionCodesSuccess = (count: number) =>
  FETCH_COUNT_REDACTION_CODES_SUCCESS({ count });

/**
 * The SOFT delete raises `isDeleted` through the save mutation;
 * DELETE_REDACTION_CODE_REQUEST above is now only reached from the deleted
 * view's permanent delete (VE-28768).
 */
/** Set the drawer open or closed outright, for callers that know which. */
export const SET_IS_DRAWER_OPEN = createAction<{ isOpen: boolean }>(
  'REDACTION_CODES/SET_IS_DRAWER_OPEN'
);

export const actionSetIsDrawerOpen = (payload: { isOpen: boolean }) =>
  SET_IS_DRAWER_OPEN(payload);

export const RESTORE_REDACTION_CODE_REQUEST = createAction<{
  sdoId: string;
}>('REDACTION_CODES/RESTORE_REDACTION_CODE_REQUEST');

export const SOFT_DELETE_REDACTION_CODE_REQUEST = createAction<{
  sdoId: string;
}>('REDACTION_CODES/SOFT_DELETE_REDACTION_CODE_REQUEST');

/**
 * Terminal actions of their own rather than the save mutation's.
 *
 * Raising the flag reuses the save MUTATION, but it must not reuse the save
 * RESULT: `saveRedactionCodeSuccess` closes the drawer and reports "Saved
 * Redaction Code successfully", neither of which is true of a delete made
 * from the table.
 */
export const SET_REDACTION_CODE_DELETED_SUCCESS =
  createGraphQLSuccessAction<SaveRedactionCodeSuccessPayload>(
    'REDACTION_CODES/SET_REDACTION_CODE_DELETED_SUCCESS'
  );
export const SET_REDACTION_CODE_DELETED_FAILURE = createGraphQLFailureAction(
  'REDACTION_CODES/SET_REDACTION_CODE_DELETED_FAILURE'
);

export const actionSoftDeleteRedactionCode = (payload: { sdoId: string }) =>
  SOFT_DELETE_REDACTION_CODE_REQUEST(payload);

export const actionRestoreRedactionCode = (payload: { sdoId: string }) =>
  RESTORE_REDACTION_CODE_REQUEST(payload);
